import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import {entityChartRoutes} from './entity-chart.routes';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import {EntityChartContentComponent} from './components/entity-chart-content/entity-chart-content.component';
import {EntityChartImportToolbarComponent} from './components/entity-chart-import/entity-chart-import-toolbar/entity-chart-import-toolbar.component'
import {EntityChartImportComponent} from './components/entity-chart-import/entity-chart-import.component';
import {EntityChartToolbarComponent} from './components/entity-chart-toolbar/entity-chart-toolbar.component';
import {EntityChartApiService} from './services/entity-chart-service';
import {entityChartReducer} from './store/reducers/entity-chart.reducer';
import {EntityChartEffect} from './store/effects/entity-chart.effects';
import {EntityChartImportExportEffect} from './store/effects/entity-chart-import-export.effects';
import { CountryTreeSelectorItemViewerComponent } from './components/country-tree-selector-item-viewer/country-tree-selector-item-viewer.component';
import { IPlatformApiProvider, PlatformApiProvider } from '@shared/services/platform-api-provider';

class EntityChartApiProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.startsWith('/orbitax-connect')) {
      return 'FileStoreApi';
    }
    return '';
  }
}

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(entityChartRoutes),
    EffectsModule.forFeature([EntityChartEffect, EntityChartImportExportEffect]),
    StoreModule.forFeature('entityChart', entityChartReducer),
    SharedModule
  ],
  declarations: [
    EntityChartContentComponent,
    EntityChartImportComponent,
    EntityChartToolbarComponent,
    EntityChartImportToolbarComponent,
    CountryTreeSelectorItemViewerComponent
  ],
  providers: [EntityChartApiService]
})
export class EntityChartModule {
  constructor(private platformApiProvider: PlatformApiProvider) {
    this.platformApiProvider.register(new EntityChartApiProvider);
  }
 }
